import React, { useState } from 'react';
import { Card, Button, Table, Alert, Space, Tag, Modal } from 'antd';
import { PlusOutlined, MobileOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDevice } from '../../contexts/DeviceContext';
import DeviceRegistration from '../device/DeviceRegistration';

interface Device {
  id: string;
  device_id: string;
  imei: string;
  name: string;
  device_type: string;
  tags?: string[];
  operation_mode: 'batch' | 'realtime';
  last_seen_at?: string;
  created_at: string;
}

const DeviceList: React.FC = () => {
  const { devices, loadDevices } = useDevice();
  const [showRegistration, setShowRegistration] = useState(false);
  const navigate = useNavigate();

  const handleDeviceRegistered = (newDevice: any) => {
    loadDevices();
    setShowRegistration(false);
    navigate(`/devices/${newDevice.id}`);
  };

  const columns = [
    {
      title: 'デバイス名',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, record: Device) => (
        <Space>
          <MobileOutlined />
          <span>{name}</span>
          {devices.length === 1 && <Tag color="blue">メイン</Tag>}
        </Space>
      ),
    },
    {
      title: 'タグ',
      dataIndex: 'tags',
      key: 'tags',
      render: (tags: string[]) => (
        <Space wrap>
          {tags?.map(tag => (
            <Tag key={tag} color="blue">{tag}</Tag>
          ))}
        </Space>
      ),
    },
    {
      title: 'IMEI',
      dataIndex: 'device_id',
      key: 'device_id',
      render: (device_id: string) => <code>{device_id}</code>,
    },
    {
      title: 'モード',
      dataIndex: 'operation_mode',
      key: 'operation_mode',
      render: (operation_mode: string) => (
        <Tag color={operation_mode === 'realtime' ? 'green' : 'default'}>
          {operation_mode === 'realtime' ? 'リアルタイム' : 'バッチ'}
        </Tag>
      ),
    },
    {
      title: '最終接続',
      dataIndex: 'last_seen_at',
      key: 'last_seen_at',
      render: (lastSeenAt: string) => 
        lastSeenAt ? new Date(lastSeenAt).toLocaleString() : '未接続',
    },
    {
      title: '操作',
      key: 'actions',
      render: (_: any, record: Device) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => navigate(`/devices/${record.id}`)}
        >
          詳細
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Card
        title={
          <Space>
            <MobileOutlined />
            デバイス
          </Space>
        }
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setShowRegistration(true)}
          >
            新規登録
          </Button>
        }
      >
        {devices.length === 0 ? (
          <Alert
            message="デバイスが登録されていません"
            description="THINKLETデバイスを登録して、自動ジャーナル機能をご利用ください。"
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}

          />
        ) : (
          <Table
            columns={columns}
            dataSource={devices}
            rowKey="id"
            pagination={false}
            size="middle"
          />
        )}
      </Card>

      <Modal
        title="新規デバイス登録"
        open={showRegistration}
        onCancel={() => setShowRegistration(false)}
        footer={null}
        width={600}
      >
        <DeviceRegistration
          onSuccess={handleDeviceRegistered}
          onCancel={() => setShowRegistration(false)}
        />
      </Modal>


    </div>
  );
};

export default DeviceList;